import * as actionTypes from './types';


const INITIAL_KEY_STATE = {
	value: null
};

const INITIAL_STATE = {
	value: {
		viewProfile: 'close',
		editProfile: 'close',
		isEditPersonalInfo: false
	},
	set: INITIAL_KEY_STATE,
};


const userReducer = (state = INITIAL_STATE, action: any) => {
	const { payload } = action;
	switch (action.type) {
		case actionTypes.SET_DATA:

			return {
				value: {
					...state.value,
					...payload
				}
			};
		default:
			return state;
	}
};

export default userReducer;
